import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'
import dayjs from 'dayjs'

class ImpactReportType extends ActiveRecord {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined

    this._id = init.id
    this._employee_id = init.employee_id
    this._client_name = init.client_name
    this._issue_type = init.issue_type
    this._issue_description = init.report_issue_description
    this._start_date = init.start_date
    this._end_date = init.end_date
    this._client_owner = init.client_owner
    this._jira_ticket_link = init.jira_ticket_link
    this._impact_amount = init.impact_amount
    this._invoice_amount = init.invoice_amount
    this._client_status = init.client_status
    this._payment_status = init.payment_status
    this._source_attachments = init.source_attachments
  }

  static shape = {
    id: PropTypes.number,
    employee_id: PropTypes.number,
    client_name: PropTypes.string,
    issue_type: PropTypes.string,
    issue_description: PropTypes.string,
    start_date: PropTypes.string,
    end_date: PropTypes.string,
    client_owner: PropTypes.string,
    jira_ticket_link: PropTypes.string,
    impact_amount: PropTypes.number,
    invoice_amount: PropTypes.number,
    client_status: PropTypes.string,
    payment_status: PropTypes.string,
    source_attachments: PropTypes.array
  }

  get id() {
    return this._id
  }

  get employee_id() {
    return this._employee_id
  }

  get client_name() {
    return this._client_name
  }

  get issue_type() {
    return this._issue_type
  }

  get issue_description() {
    return this._issue_description
  }

  get start_date() {
    return this._start_date
      ? dayjs(new Date(this._start_date).toISOString())
      : null
  }

  get end_date() {
    return this._end_date ? dayjs(new Date(this._end_date).toISOString()) : null
  }

  get client_owner() {
    return this._client_owner
  }

  get jira_ticket_link() {
    return this._jira_ticket_link
  }

  get impact_amount() {
    return this._impact_amount
  }

  get invoice_amount() {
    return this._invoice_amount
  }

  get client_status() {
    return this._client_status
  }

  get payment_status() {
    return this._payment_status
  }

  get source_attachments() {
    return this._source_attachments
  }
}

export default ImpactReportType
